module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"tag":"Видеособеседование","title":"Настройка камеры","namePlaceholder":"Введите ваше имя","enterWithVideo":"Войти с видео","enterWithoutVideo":"Войти без видео","requestingCamera":"Запрашиваем доступ к камере...","noCamera":"Камера не обнаружена","connecting":"Подключение..."}}')
  delete Component.options._Ctor
}
